import * as React from 'react';

function SvgChatboxEllipses(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M18.786 3H5.214A3.218 3.218 0 002 6.214v8.572A3.218 3.218 0 005.214 18h1.072v2.857a.714.714 0 001.172.549L11.542 18h7.244A3.218 3.218 0 0022 14.786V6.214A3.218 3.218 0 0018.786 3zM7.714 11.929a1.428 1.428 0 110-2.857 1.428 1.428 0 010 2.857zm4.286 0a1.429 1.429 0 110-2.858 1.429 1.429 0 010 2.858zm4.286 0a1.429 1.429 0 110-2.858 1.429 1.429 0 010 2.858z" })));
}

export default SvgChatboxEllipses;
